import React from 'react';
import {observer} from 'mobx-react-lite';
import './render-double-stack.scss';
import {PCS_CSS} from '../../i';
import s from '../../s';

interface Props {
    css: PCS_CSS;
}

export const RenderDoubleStack = observer(({css}: Props) => {
    return (
        <div
            id="frame-double-stack"
            style={{
                aspectRatio: css.double_stack_aspect_ratio,
                width: css.double_stack_is_vertical ? 'auto' : '80%',
                height: css.double_stack_is_vertical ? '100%' : '',
                backgroundImage: s.prod.BackgroundPartURL,
            }}
        >
            <img
                id="document-image"
                alt="Document Image"
                src={css.doc1_src}
                style={{
                    width: `${css.double_stack_width}%`,
                    height: `${css.double_stack_height}%`,
                }}
            />
        </div>
    );
});
